import React, { useContext, useState, useRef, useEffect } from 'react';
import ResponsiveBox, {
  Row, Col, Item, Location,
} from 'devextreme-react/responsive-box';
import TenantContext from '../../contexts/tenantContext';
import Button from 'devextreme-react/button';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { DataGrid, Column, Editing, Paging, GroupPanel } from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import { EmergenzaDTO, EmergenzeApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { LoadPanel } from 'devextreme-react';
import EmergenzaEmptyPanel from '../../components/emergenze/EmergenzaEmptyPanel';
import EmergenzaEditPanel from '../../components/emergenze/EmergenzaEditPanel';


export default function Emergenze() {
  const { currentTenant } = useContext(TenantContext);
  const [emergenza, setEmergenza] = useState<EmergenzaDTO | null | undefined>();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [title, setTitle] = React.useState<string>("Gestione Emergenza");


const refreshData = async () => {
      var api = new EmergenzeApi(apiConfiguration);

      var emergenza = await api.getCurrentEmergenza({ tenantId: currentTenant.Id });
      setEmergenza(emergenza);

      if (emergenza)
        setTitle("Gestione Emergenza - " + emergenza.nome);
      else
        setTitle("Gestione Emergenza");
    };

  useEffect(() => {
    setLoading(true);

    refreshData()
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [currentTenant]);

  return (
    <React.Fragment>
      <h2 className={'content-block'}>{title}</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
          {!loading && emergenza && <EmergenzaEditPanel emergenza={emergenza} onChanged={refreshData} />}

          {!loading && !emergenza && <EmergenzaEmptyPanel onChanged={refreshData} />}

          <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={{ of: '.dx-card' }}
            visible={loading}
            showIndicator={true}
            shading={false}
            showPane={true}
            hideOnOutsideClick={false}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
